import isEmpty from 'lodash/isEmpty';
import BrSlugsJson from 'Translations/slugs.br.json';
import DeSlugsJson from 'Translations/slugs.de.json';
import EsSlugsJson from 'Translations/slugs.es.json';
import FrSlugsJson from 'Translations/slugs.fr.json';
import ItSlugsJson from 'Translations/slugs.it.json';
import NlSlugsJson from 'Translations/slugs.nl.json';
import RuSlugsJson from 'Translations/slugs.ru.json';

type SlugType = {
  [key: string]: {
    [key: string]: string;
  };
};

const slugs: SlugType = {
  br: BrSlugsJson,
  de: DeSlugsJson,
  es: EsSlugsJson,
  fr: FrSlugsJson,
  it: ItSlugsJson,
  nl: NlSlugsJson,
  ru: RuSlugsJson
};

export const getEnglishSlug = (slug: string, lang = 'en') => {
  if (lang === 'en') return slug;

  return slugs[lang][slug];
};

export const getTranslatedSlug = (englishSlug: string, lang = 'en') => {
  if (isEmpty(lang) || lang === 'en') return englishSlug;

  const translatedSlug = slugs[lang];

  return Object.keys(translatedSlug).find(key => {
    return translatedSlug[key] === englishSlug;
  });
};
